import React from 'react';

import { Footer, Header } from '$partials/global';
import { ModuleDispatcher } from '$partials/modules';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/pages.d.ts').HygienePage}
 */
const HygienePage = (props) => {
    const page = props.data.page;
    return (
        <>
            <Header
                {...props?.data?.header}
                articleLandingPageUrl={props?.data?.articleLandingPageUrl}
                pageType={page.__typename} />

            <main id='main-content'>
                <div className='layout-container layout-site-outer-padding pb-8 md:pb-16'>
                    {/* Main Content */}
                    <div className='col-wrapper-breakout flex flex-wrap rounded-lg bg-surface-panel-white'>
                        {/* Left Col */}
                        <div className='w-full sm:w-9/12 md:w-8/12 flex flex-col gap-24 py-16'>
                            <section className='flex flex-col gap-16 sm:gap-32'>
                                <div className='flex flex-col gap-8 col-padding'>
                                    {/* Title */}
                                    <h1 className='type-style-sans-display'>
                                        {page.title}
                                    </h1>

                                    {page.hygieneStandfirst && (
                                        <h2 className='type-style-serif-h3 w-full sm:pr-56 md:pr-0 md:w-3/4'>
                                            {page.hygieneStandfirst}
                                        </h2>
                                    )}

                                </div>
                            </section>

                            {/* Modules*/}
                            {page?.modules?.length > 0 && (
                                <div className='flex flex-col gap-32'>
                                    {page?.modules?.map((module, idx) => (
                                        <ModuleDispatcher
                                            {...module}
                                            key={module?.id + '-' + idx} />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </main>

            <Footer
                {...props?.data?.footer}
                exploreTags={
                    page.tags?.length > 0 ?
                        { edges: page.tags.map(tag =>({ node: tag }))}
                        : props?.data?.footer?.exploreTags
                }
                newsletterHide={!page.showNewsletter}
                pageType={page.__typename} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default HygienePage;
